import React from 'react';
import createSvgIcon from '@mui/icons-material/utils/createSvgIcon';
import parseColor from '../util/parseColor';
import { styled } from '../styled';

const Icon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 19 16'
    fill='none'
    color='inherit'
  >
    <path
      d='m3.375 16 1-4h-4l.5-2h4l1-4h-4l.5-2h4l1-4h2l-1 4h4l1-4h2l-1 4h4l-.5 2h-4l-1 4h4l-.5 2h-4l-1 4h-2l1-4h-4l-1 4zm3.5-6h4l1-4h-4z'
      fill='currentColor'
    />
  </svg>,
  'TagItalic',
);

const ColoredIcon = styled(Icon)(({ theme, color }) => ({
  color: parseColor(theme, color),
}));

export default ColoredIcon;
